<template>
  <div>
    <v-autocomplete
      v-model="relatorio_selecionado"
      :items="itens"
      item-value="idaplicativo"
      item-text="descricao_aplicativo"
      label="Selecione um relatório"
      v-bind="$attrs"
      :loading="carregando_dados"
      color="primary"
    />

    <ExportacaoCissPoder
      v-model="dialog_exportacao_cisspoder"
      :pedido-selecionado="pedido_compra"
      @fechar="selecionarRelatorioPDF()"
      @relatorio-gerado="$emit('relatorio-gerado', $event)"
    />

    <ExportacaoProtheus
      v-if="pedido_compra.grupo && EXPORTACAO_PROTHEUS_HABILITADA"
      v-model="dialog_exportacao_protheus"
      :pedidoSelecionado="pedido_compra"
      :produtoInvalidoParaExportacao="false"
      @fechar="selecionarRelatorioPDF()"
      @exportacao-com-sucesso="$emit('relatorio-gerado', $event)"
    />

    <ExportacaoRMS
      v-model="dialog_exportacao_rms"
      :pedidoSelecionado="pedido_compra"
      @fechar="selecionarRelatorioPDF()"
      @exportacao-com-sucesso="$emit('relatorio-gerado', $event)"
    ></ExportacaoRMS>

    <ExportacaoPedidosSankhya
      v-model="dialog_exportacao_sankhya"
      :pedido="pedido_compra"
      :produtos_pedido="produtos_pedido_selecionado"
      :resultados_exportacao="RESULTADO_DELECAO_PRODUTO_EXPORTACAO_SANKHYA"
      @fechar="selecionarRelatorioPDF()"
      @exportado-com-sucesso="ev => $emit('sankhya:pedido-exportado', ev)"
    />

    <ExportacaoCissPoderIntegrim
      v-model="dialog_exportacao_ciss_poder_integrim"
      :pedido="pedido_compra"
      :produtos_pedido="produtos_pedido_selecionado"
      @exportado-com-sucesso="ev => $emit('ciss-poder-integrim:pedido-exportado', ev)"
    />

    <ExportacaoTateti
      v-model="dialog_exportacao_tateti"
      :pedidoSelecionado="pedido_compra"
      @reset-exportacao-tateti="buscarListaRelatorios()"
    />

    <ExportacaoGemco
      :pedido="pedido_compra"
      :produtos_pedido="produtos_pedido_selecionado"
      :dialog_ativo="dialog_exportacao_gemco"
      @update:dialog-ativo="valor => dialog_exportacao_gemco = valor"
      @exportado-com-sucesso="ev => $emit('gemco:pedido-exportado', ev)"
    />

    <ExportacaoCitel
      :pedido="pedido_compra"
      :produtos_pedido="produtos_pedido_selecionado"
      :dialog_ativo="dialog_exportacao_citel"
      @update:dialog-ativo="valor => dialog_exportacao_citel = valor"
      @exportado-com-sucesso="ev => $emit('citel:pedido-exportado', ev)"
    />

    <ExportacaoNerus
      :pedido="pedido_compra"
      :produtos_pedido="produtos_pedido_selecionado"
      :dialog_ativo="dialog_exportacao_nerus"
      @update:dialog-ativo="valor => dialog_exportacao_nerus = valor"
      @exportado-com-sucesso="$emit('nerus:pedido-exportado', $event)"
    />

    <ExportacaoDunorte
      :pedido="pedido_compra"
      :dialog_ativo="dialog_exportacao_dunorte"
      @update:dialog-ativo="valor => dialog_exportacao_dunorte = valor"
      @exportado-com-sucesso="$emit('dunorte:pedido-exportado', $event)"
    />

    <ExportacaoCasaTudoSacolao
      v-model="dialog_exportacao_casa_tudo_sacolao"
      :pedido="pedido_compra"
      :produtos_pedido="produtos_pedido_selecionado"
      @exportado-com-sucesso="ev => $emit('casa-tudo-sacolao:pedido-exportado', ev)"
    />

    <ExportacaoNativaWinthor
      :pedido="pedido_compra"
      :produtos_pedido="produtos_pedido_selecionado"
      :dialog_ativo="dialog_exportacao_nativa_winthor"
      @update:dialog-ativo="valor => dialog_exportacao_nativa_winthor = valor"
      @exportado-com-sucesso="ev => $emit('nativa-winthor:pedido-exportado', ev)"
    />

    <ExportacaoPadreCicero
      v-if="dialog_exportacao_padre_cicero"
      :dialog_ativo="dialog_exportacao_padre_cicero"
      :pedido="pedido_compra"
      :produtos_pedido="produtos_pedido_selecionado"
      @update:dialog-ativo="dialog_exportacao_padre_cicero = $event; $emit('padre-cicero:pedido-exportado', {})"
    />

    <ExportacaoWinthorApi
      v-if="dialog_exportacao_winthor_api"
      :dialog_ativo="dialog_exportacao_winthor_api"
      :pedido="pedido_compra"
      :produtos_pedido="produtos_pedido_selecionado"
      @update:dialog-ativo="dialog_exportacao_winthor_api = $event; $emit('winthor-api:pedido-exportado', {})"
    />

    <ExportacaoApiPedidosSystock
      v-model="dialog_exportacao_api_pedidos_systock"
      :pedido="pedido_compra"
      :produtos_pedido="produtos_pedido_selecionado"
      @update:modelValue="$emit('api-pedidos-systock:pedido-exportado', {})"
    />

    <ExportacaoApiPedidosSystockAndra
      v-model="dialog_exportacao_api_pedidos_systock_andra"
      :pedido="pedido_compra"
      :produtos_pedido="produtos_pedido_selecionado"
      @update:modelValue="$emit('api-pedidos-systock:pedido-exportado', {})"
    />

    <v-dialog
      v-model="dialog_escolha_tipo_exportacao_consinco"
      max-width="440"
      persistent
    >
      <v-card>
        <v-card-title class="headline pb-2">
          Exportação Consinco
        </v-card-title>
        <v-card-text class="pt-0">
          <!-- Temporário: só fluxo sugestão de compra
          <p class="mb-4 body-2">
            Escolha como deseja prosseguir.
          </p>
          <v-btn
            block
            color="primary"
            class="mb-3"
            @click="abrirExportacaoConsincoPedidoCompra"
          >
            Criar pedido de compra
          </v-btn>
          -->
          <v-btn
            block
            outlined
            color="primary"
            @click="abrirExportacaoConsincoSugestao"
          >
            Criar sugestão de compra
          </v-btn>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialog_escolha_tipo_exportacao_consinco = false">
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ExportacaoPedidoCompraConsinco
      :pedido="pedido_compra"
      :produtos_pedido="produtos_pedido_selecionado"
      :dialog_ativo="dialog_exportacao_consinco"
      @update:dialog-ativo="valor => dialog_exportacao_consinco = valor"
      @exportado-com-sucesso="ev => $emit('consinco:pedido-exportado', ev)"
    />

    <ExportacaoSugestaoCompraConsinco
      :pedido="pedido_compra"
      :produtos_pedido="produtos_pedido_selecionado"
      :dialog_ativo="dialog_exportacao_consinco_sugestao"
      @update:dialog-ativo="valor => dialog_exportacao_consinco_sugestao = valor"
      @exportado-com-sucesso="ev => $emit('consinco:pedido-exportado', ev)"
    />
  </div>
</template>

<script>
import CarrinhoAPI from "../../../api/carrinho";
import ExportacaoCissPoder from "../../compra/carrinho/ExportacaoCissPoder.vue";
import ExportacaoProtheus from "../../compra/carrinho/ExportacaoProtheus";
import ExportacaoRMS from "../../compra/carrinho/ExportacaoRMS";
import ExportacaoPedidosSankhya from "@/components/compra/carrinho/exportacaoSankhya/Index.vue";
import ExportacaoCissPoderIntegrim from "@/components/compra/carrinho/Exportacoes/ExportacaoCissPoderIntegrim/Index.vue";
import ExportacaoTateti from "@/components/compra/carrinho/Exportacoes/ExportacaoTateti.vue";
import ExportacaoShopControll9 from "@/components/compra/carrinho/Exportacoes/ExportacaoShopControll9.vue";
import ExportacaoGemco from "@/components/compra/carrinho/Exportacoes/ExportacaoGemco/Index.vue";
import ExportacaoCitel from "@/components/compra/carrinho/Exportacoes/ExportacaoCitel/Index.vue";
import ExportacaoNerus from "@/components/compra/carrinho/Exportacoes/Nerus/Index.vue";
import ExportacaoDunorte from "@/components/compra/carrinho/Exportacoes/Dunorte/Index.vue";
import ExportacaoCasaTudoSacolao from "@/components/compra/carrinho/Exportacoes/ExportacaoCasaTudoSacolao/Index.vue";
import ExportacaoNativaWinthor from "@/components/compra/carrinho/Exportacoes/NativaWinthor/Index.vue";
import ExportacaoPadreCicero from "@/components/compra/carrinho/Exportacoes/PadreCicero/Index.vue";
import ExportacaoWinthorApi from "@/components/compra/carrinho/Exportacoes/WinthorApi/Index.vue";
import ExportacaoApiPedidosSystock from "@/components/compra/carrinho/Exportacoes/ExportacaoApiPedidosSystock/Index.vue";
import ExportacaoApiPedidosSystockAndra from "@/components/compra/carrinho/Exportacoes/ExportacaoApiPedidosSystockAndra/Index.vue";
import ExportacaoPedidoCompraConsinco from "@/components/compra/carrinho/Exportacoes/ExportacaoApiPedidosConsinco/PedidoCompra/Index.vue";
import ExportacaoSugestaoCompraConsinco from "@/components/compra/carrinho/Exportacoes/ExportacaoApiPedidosConsinco/SugestaoCompra/Index.vue";

const ERRO_PEDIDO_NAO_EXISTE = "Pedido de compra não passado como prop. Relatório Cisspoder precisa ser associado a um pedido de compra";

export default {
  name: "SysRelatoriosCompra",
  components: {
    ExportacaoGemco,
    ExportacaoShopControll9,
    ExportacaoTateti,
    ExportacaoCissPoder,
    ExportacaoProtheus,
    ExportacaoRMS,
    ExportacaoPedidosSankhya,
    ExportacaoCissPoderIntegrim,
    ExportacaoCitel,
    ExportacaoNerus,
    ExportacaoDunorte,
    ExportacaoCasaTudoSacolao,
    ExportacaoNativaWinthor,
    ExportacaoPadreCicero,
    ExportacaoWinthorApi,
    ExportacaoApiPedidosSystock,
    ExportacaoApiPedidosSystockAndra,
    ExportacaoPedidoCompraConsinco,
    ExportacaoSugestaoCompraConsinco,
  },
  model: {
    prop: "valor_modelo",
    event: "atualizar:valor_modelo"
  },
  props: {
    valor_modelo: {
      type: Object,
      required: true
    },
    pedido_compra: {
      type: Object,
      default: null
    },
    auto_select_relatorio_pdf: {
      type: Boolean,
      default: false
    },
    produtos_pedido_selecionado: {
      type: Array,
      default: () => ([])
    },
    click_botao_gerar_count: Number,
  },
  data: () => ({
    itens: [],
    carregando_dados: false,
    dialog_exportacao_cisspoder: false,
    dialog_exportacao_protheus: false,
    dialog_exportacao_rms: false,
    dialog_exportacao_sankhya: false,
    dialog_exportacao_ciss_poder_integrim: false,
    dialog_exportacao_tateti: false,
    dialog_exportacao_gemco: false,
    dialog_exportacao_citel: false,
    dialog_exportacao_nerus: false,
    dialog_exportacao_dunorte: false,
    dialog_exportacao_casa_tudo_sacolao: false,
    dialog_exportacao_nativa_winthor: false,
    dialog_exportacao_padre_cicero: false,
    dialog_exportacao_winthor_api: false,
    dialog_exportacao_api_pedidos_systock: false,
    dialog_exportacao_api_pedidos_systock_andra: false,
    dialog_exportacao_consinco: false,
    dialog_escolha_tipo_exportacao_consinco: false,
    dialog_exportacao_consinco_sugestao: false,
  }),
  computed: {
    relatorio_selecionado: {
      get: function () {
        return this.valor_modelo;
      },
      set: function (novo_valor) {
        this.$emit("atualizar:valor_modelo", novo_valor);
      }
    },
    RESULTADO_DELECAO_PRODUTO_EXPORTACAO_SANKHYA() {
      return this.$store.getters['ExportacaoPedidoCompraParaERP/resultado_exportacao_sankha'];
    },
    EXPORTACAO_PROTHEUS_HABILITADA() {
      return localStorage.integracao_exportacao_compra_protheus === 'S';
    },
  },
  watch: {
    pedido_compra() {
      this.buscarListaRelatorios();
    },
    relatorio_selecionado() {
      if (this.relatorio_selecionado.src_aplicativo === "relatorios/pedido-compra/tateti") {
        this.verificarRelatorioExportacaoTateti();
        return;
      }

      this.verificarRelatorioCisspoder();
      this.verificarRelatorioExportacaoRMS();
      this.verificarRelatorioExportacaoSankhya();
      this.verificarRelatorioExportacaoCissPoderIntegrim();
      this.verificarRelatorioExportacaoProtheus();
    },
    dialog_exportacao_ciss_poder_integrim(valor) {
      if (!valor) {
        this.selecionarRelatorioPDF();
      }
    },
    click_botao_gerar_count() {
      const src = this.relatorio_selecionado && this.relatorio_selecionado.src_aplicativo;
      if (src === 'relatorios/pedido-compra/api-consinco') {
        this.dialog_escolha_tipo_exportacao_consinco = true;
        return;
      }

      const mapa_url_relatorio_versos_dialog = {
        'relatorios/pedido-compra/gemco': 'dialog_exportacao_gemco',
        'relatorios/pedido-compra/citel': 'dialog_exportacao_citel',
        'relatorios/pedido-compra/nerus-csv': 'dialog_exportacao_nerus',
        'relatorios/pedido-compra/dunorte': 'dialog_exportacao_dunorte',
        'relatorios/pedidos-compra/casa-tudo-sacolao/exportacao-pedido': 'dialog_exportacao_casa_tudo_sacolao',
        'relatorios/pedido-compra/nativo-winthor': 'dialog_exportacao_nativa_winthor',
        'relatorios/pedido-compra/padre-cicero': 'dialog_exportacao_padre_cicero',
        'relatorios/pedido-compra/winthor-api': 'dialog_exportacao_winthor_api',
        'relatorios/api-pedidos-systock': 'dialog_exportacao_api_pedidos_systock',
        'relatorios/api-pedidos-systock-andra': 'dialog_exportacao_api_pedidos_systock_andra',
      };

      const dialog = mapa_url_relatorio_versos_dialog[src];

      if (dialog) {
        this[dialog] = true;
      }
    }
  },
  created() {
    this.carregando_dados = true;
    this.buscarListaRelatorios();
  },
  methods: {
    buscarListaRelatorios() {
      const headers = this.Helpers.iniciarRequisicao();

      CarrinhoAPI.getRelatoriosCarrinho(headers)
        .then(resp => {
          const {token, relatorios} = resp.data;
          localStorage.token = token;
          this.itens = relatorios;
          this.carregando_dados = false;

          if (this.auto_select_relatorio_pdf) {
            this.selecionarRelatorioPDF();
          }
        })
        .catch(() => this.Helpers.logout());
    },
    selecionarRelatorioPDF() {
      if (this.itens[0]) {
        const naoPodeSerDefault = ["CISSPODER", "PROTHEUS", "RMS"];

        const lengthR = this.itens.length;

        for (let i = 0; i < lengthR; i++) {
          const relatorio = this.itens[i];

          const valido = naoPodeSerDefault.includes(relatorio.sigla_sistema);

          if (!valido) {
            this.relatorio_selecionado = relatorio;
            i = lengthR;
          }
        }
      }
    },
    verificarRelatorioCisspoder() {
      if (this.relatorio_selecionado.sigla_sistema !== "CISSPODER") return;

      if (!this.pedido_compra) {
        console.error(ERRO_PEDIDO_NAO_EXISTE)
        return;
      }

      this.dialog_exportacao_cisspoder = true;
    },
    verificarRelatorioExportacaoProtheus() {
      if (this.relatorio_selecionado.sigla_sistema !== "PROTHEUS") return;

      if (!this.pedido_compra) {
        console.error(ERRO_PEDIDO_NAO_EXISTE)
        return;
      }

      this.dialog_exportacao_protheus  = true;
    },
    verificarRelatorioExportacaoTateti() {
      if (this.relatorio_selecionado.src_aplicativo !== "relatorios/pedido-compra/tateti") return;

      if (!this.pedido_compra) {
        console.error(ERRO_PEDIDO_NAO_EXISTE)
        return;
      }

      this.dialog_exportacao_tateti  = true;
    },
    verificarRelatorioExportacaoRMS() {
      if (this.relatorio_selecionado.sigla_sistema !== "RMS") return;

      if (!this.pedido_compra) {
        console.error(ERRO_PEDIDO_NAO_EXISTE)
        return;
      }

      this.dialog_exportacao_rms  = true;
    },
    verificarRelatorioExportacaoSankhya() {
      if (this.relatorio_selecionado.sigla_sistema !== "SANKHYA") return;

      if (!this.pedido_compra) {
        console.error(ERRO_PEDIDO_NAO_EXISTE)
        return;
      }

      this.dialog_exportacao_sankhya  = true;
    },
    verificarRelatorioExportacaoCissPoderIntegrim() {
      if (this.relatorio_selecionado.src_aplicativo === "relatorios/pedido-compra/ciss-poder-integrim") {
        this.dialog_exportacao_ciss_poder_integrim = true;
      }
    },
    verificarRelatorioExportacaoNerus() {
      if (this.relatorio_selecionado.src_aplicativo === "relatorios/pedido-compra/nerus-csv") {
        this.dialog_exportacao_nerus = true;
      }
    },
    verificarRelatorioExportacaoPadreCicero() {
      if (this.relatorio_selecionado.src_aplicativo === "relatorios/pedido-compra/padre-cicero") {
        this.dialog_exportacao_padre_cicero = true;
      }
    },
    abrirExportacaoConsincoPedidoCompra() {
      this.dialog_escolha_tipo_exportacao_consinco = false;
      this.dialog_exportacao_consinco = true;
    },
    abrirExportacaoConsincoSugestao() {
      this.dialog_escolha_tipo_exportacao_consinco = false;
      this.dialog_exportacao_consinco_sugestao = true;
    },
  }
}
</script>

<style scoped>
</style>
